import {
  PROFISSIONAL_SELECT_EMPTY,
  PROFISSIONAL_SELECT_LOADING,
  PROFISSIONAL_SELECT_PLACEHOLDER,
} from "./profissional-select.constants";
import type { ProfissionalSelectProps } from "./types-profissional-select";

/** Mensagens do menu e o valor devolvido ao limpar (`null`); carregando, o campo fica inerte. */
export function useProfissionalSelect({
  value,
  options,
  onChange,
  placeholder = PROFISSIONAL_SELECT_PLACEHOLDER,
  emptyMessage = PROFISSIONAL_SELECT_EMPTY,
  errorMessage = null,
  loading = false,
  disabled = false,
  ariaLabel,
  className,
  invalid = false,
  testId,
  id,
  name,
  "aria-describedby": ariaDescribedBy,
}: ProfissionalSelectProps) {
  return {
    value,
    options,
    placeholder: loading ? PROFISSIONAL_SELECT_LOADING : placeholder,
    emptyFilterMessage: emptyMessage,
    emptyMessage: errorMessage ?? emptyMessage,
    disabled: disabled || loading,
    ariaLabel,
    className,
    invalid,
    testId,
    id,
    name,
    ariaDescribedBy,
    selecionar: (novo: string | null | undefined) => onChange(novo ?? null),
  };
}
